const features = [
    {
        icon: 'las la-eye',
        heading: 'Matching anónimo y antisesgos',
        excerpt: 'Inlcuimos los perfiles descartados por edad, género o ...',
        to: '/feature-detail-1'
    },
    {
        icon: 'las la-sync-alt',
        heading: 'Algoritmo bi-direccional',
        excerpt: 'Conexión transparente entre empresa y candidato...',
        to: '/feature-detail-1'
    },
    {
        icon: 'lab la-wpforms',
        heading: 'Assessment Woowii',
        excerpt: 'Onboarding personalizado para crear perfiles reales...',
        to: '/feature-detail-1'
    },
    {
        icon: 'las la-history',
        heading: 'Reducción de  costo en la selección',
        excerpt: 'Evaluación integral para optimizar el proceso...',
        to: '/feature-detail-1'
    },
    {
        icon: 'las la-filter',
        heading: 'Historias en lugar de CV',
        excerpt: 'Oportunidades para candidatos automáticamente descartados...',
        to: '/feature-detail-1'
    },
    {
        icon: 'las la-brain',
        heading: 'La IA que sí entiende de personas',
        excerpt: 'Por qué necesitamos a Woowii en el mercado...',
        to: '/feature-detail-1'
    },
    // {
    //     icon: 'las la-comments',
    //     heading: 'Easy to Use',
    //     excerpt: 'Heat multiply is second divided fowl there isnt man cattle they wherein lights greater concern open days tree is brought.',
    //     to: '/feature-detail-1'
    // },
    // {
    //     icon: 'las la-headset',
    //     heading: 'Made for Everyone',
    //     excerpt: 'Heat multiply is second divided fowl there isnt man cattle they wherein lights greater concern open days tree is brought.',
    //     to: '/feature-detail-1'
    // },
    // {
    //     icon: 'las la-photo-video',
    //     heading: 'Share Everything',
    //     excerpt: 'Heat multiply is second divided fowl there isnt man cattle they wherein lights greater concern open days tree is brought.',
    //     to: '/feature-detail-1'
    // },
    // {
    //     icon: 'las la-server',
    //     heading: 'Unlimited Storage',
    //     excerpt: 'Heat multiply is second divided fowl there isnt man cattle they wherein lights greater concern open days tree is brought.',
    //     to: '/feature-detail-1'
    // },
    // {
    //     icon: 'las la-user-lock',
    //     heading: 'Data Protection',
    //     excerpt: 'Heat multiply is second divided fowl there isnt man cattle they wherein lights greater concern open days tree is brought.',
    //     to: '/feature-detail-1'
    // },
    // {
    //     icon: 'las la-map-marked-alt',
    //     heading: 'Use from Anywhere',
    //     excerpt: 'Heat multiply is second divided fowl there isnt man cattle they wherein lights greater concern open days tree is brought.',
    //     to: '/feature-detail-1'
    // }
];

export default features;